import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { Token } from '@/domain/types/Token'

export interface CalculateMaxBalanceTokenAndTotalParams {
  assets: Token[]
  tokenRepository: TokenRepository
}

export interface CalculateMaxBalanceTokenAndTotalResult {
  maxBalanceToken: Token
  totalUSD: NormalizedNumber
}

export function calculateMaxBalanceTokenAndTotal({
  assets,
  tokenRepository,
}: CalculateMaxBalanceTokenAndTotalParams): CalculateMaxBalanceTokenAndTotalResult {
  const totalUSD = assets.reduce(
    (acc, token) => acc.plus(token.toUSD(tokenRepository.findOneBalanceOrZero(token.symbol))),
    NormalizedNumber.ZERO,
  )
  const maxBalanceToken = assets.reduce((acc, token) => {
    const tokenBalance = tokenRepository.findOneBalanceOrZero(token.symbol)
    const accBalance = tokenRepository.findOneBalanceOrZero(acc.symbol)
    return tokenBalance.gt(accBalance) ? token : acc
  }, assets[0]!)

  return { totalUSD, maxBalanceToken }
}
